import { EntretienFormBuilder } from './entretien-form.builder';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Demande } from '../../models/demande.model';
import { Entretien } from '../../models/entretien.model';
import { DatesValidator } from '../../validators/dates.validator';

export class CalendrierFormBuilder {
  constructor(
    private fb: UntypedFormBuilder,
    private demande: Demande,
    private isDisabled: boolean,
  ) { }

  build(): UntypedFormGroup {
    return this.fb.group({

      entretiens: this.fb.array(
        this.demande.entretiens.map((entretien: Entretien) => new EntretienFormBuilder(
          this.fb,
          entretien,
          this.isDisabled,
        ).build())
      ),

      remarqueEntretiens: this.fb.control(
        {
          value: this.demande.remarqueEntretiens,
          disabled: this.isDisabled,
        },
        [Validators.maxLength(10000)]
      ),

      dateSignature: this.fb.control(
        {
          value: this.demande.dateSignature,
          disabled: this.isDisabled,
        },
        [Validators.required]
      ),

      dateFinDelaiRetractation: this.fb.control(
        {
          value: this.demande.dateFinDelaiRetractation,
          disabled: this.isDisabled,
        }
      ),

      dateFinDelaiInstruction: this.fb.control(
        {
          value: this.demande.dateFinDelaiInstruction,
          disabled: this.isDisabled,
        }
      ),

      dateEnvisageeRupture: this.fb.control(
        {
          value: this.demande.dateEnvisageeRupture,
          disabled: this.isDisabled,
        },
        [Validators.required]
      ),

      autresClauses: this.fb.control(
        {
          value: this.demande.autresClauses,
          disabled: this.isDisabled,
        },
        [Validators.maxLength(10000)]
      ),
    },
      {
        validators: [
          DatesValidator.isDateEnvisageeRuptureValide,
          DatesValidator.isDateSignaturePosterieurEntretien
        ]
      }
    );
  }
}
